module.exports = __webpack_public_path__ + "static/media/black_car.99d3df35.png";